import React, { PureComponent, Fragment } from 'react'
import { Route } from 'react-router-dom'
import { connect } from 'react-redux'
// local components
import ApiUrl from './ApiUrl'
import MigrateCompanyProductsPage from './MigrateCompanyProductsPage'
import config from '../../../config/config'

class DevelopmentPage extends PureComponent {
  render() {
    const { match } = this.props
    const isDevEnvironment = config.apiFB
    const isBlazeAdmin = this.props?.authReducer?.session?.employee?.isBlazeAdmin || false
    return (
      <Fragment>
        {isDevEnvironment && <Route exact path={`${match.url}/apiurl`} component={ApiUrl} />}
        {isBlazeAdmin && (
          <Route
            exact
            path={`${match.url}/migrateCompanyProducts`}
            component={MigrateCompanyProductsPage}
          />
        )}
      </Fragment>
    )
  }
}

export default connect(({ authReducer, ...state }) => ({
  authReducer,
}))(DevelopmentPage)



// WEBPACK FOOTER //
// ./src/containers/Settings/Development/DevelopmentPage.js